import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Collapse, ListItem } from '@material-ui/core';
import ChevronDownIcon from '../icons/ChevronDown';
import ChevronRightIcon from '../icons/ChevronRight';
import { Tooltip } from '@mui/material';

const NavItem = (props) => {
  const { active, children, depth, icon, info, open: openProp, path, title, drawerOpen, openMobile, ...other } = props;
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 16;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }
    // Branch
    if (children) {
      return (
        <ListItem
          disableGutters
          sx={{
            display: 'block',
            py: 0.5,
          }}
          {...other}
        >
          <Button
            endIcon={!open ? <ChevronRightIcon fontSize="small" />
              : <ChevronDownIcon fontSize="small" />}
            onClick={handleToggle}
            startIcon={icon}
            sx={{
              color: 'menu.primary',
              fontWeight: 'fontWeightMedium',
              justifyContent: 'flex-start',
              pl: `${paddingLeft}px`,
              pr: '16px',
              py: '10px',
              textAlign: 'left',
              textTransform: 'none',
              width: '100%',
              borderRadius: '12px',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.04)',
                transform: 'translateX(4px)'
              }
            }}
            variant="text"
          >
            <Box sx={{ flexGrow: 1, ...(drawerOpen === false && !openMobile && { opacity: 0, width: 0, overflow: 'hidden' }), transition: 'opacity 0.2s' }}>
              {title}
            </Box>
            {drawerOpen !== false && info}
          </Button>
          <Collapse in={open}>
            {children}
          </Collapse>
        </ListItem>
      );
    }

  // Leaf
  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        py: 0.5,
      }}
    >
      {(drawerOpen || openMobile) ? (
        <>
          <Button
            component={path && RouterLink}
            startIcon={icon}
            sx={{
              color: 'menu.primary',
              fontWeight: 'fontWeightMedium',
              justifyContent: 'flex-start',
              textAlign: 'left',
              pl: `${paddingLeft}px`,
              pr: '16px',
              py: '10px',
              textTransform: 'none',
              width: '100%',
              borderRadius: '12px',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.04)',
                transform: 'translateX(4px)'
              },
              ...(active && {
                color: 'menu.primary',
                fontWeight: 'fontWeightBold',
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                boxShadow: 'inset 4px 0 0 #3b82f6',
                '& svg': {
                  color: '#3b82f6'
                },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.12)',
                  transform: 'translateX(4px)'
                }
              })
            }}
            variant="text"
            to={path}
            onClick={props.onClick}
          >
            <Box sx={{ flexGrow: 1 }}>
              {title}
            </Box>
            {info}
          </Button>
        </>
      )
        : (
          <>
            <Tooltip title={title} placement="right">
              <Button
                component={path && RouterLink}
                startIcon={icon}
                sx={{
                  color: 'menu.primary',
                  justifyContent: 'center',
                  minWidth: 'unset',
                  p: '12px',
                  borderRadius: '12px',
                  transition: 'all 0.2s ease-in-out',
                  '& .MuiButton-startIcon': {
                    margin: 0
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.04)',
                    transform: 'scale(1.05)'
                  },
                  ...(active && {
                    color: 'menu.primary',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    boxShadow: 'inset 4px 0 0 #3b82f6',
                    '& svg': {
                      color: '#3b82f6'
                    },
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.12)',
                      transform: 'scale(1.05)'
                    }
                  })
                }}
                variant="text"
                to={path}
                onClick={props.onClick}
              />
            </Tooltip>

          </>
        )}
    </ListItem>
  );
};

NavItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number.isRequired,
  icon: PropTypes.node,
  info: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  drawerOpen: PropTypes.bool,
  openMobile: PropTypes.bool
};

NavItem.defaultProps = {
  active: false,
  open: false
};

export default NavItem;
